import { useCallback } from 'react';
import { type NavigateOptions, useLocation, useNavigate } from 'react-router';

import { useFeatureFlagEnabled } from '@/hooks/featureFlags/useFeatureFlagEnabled';
import {
  AGENT_PARAM,
  ONESTEP_AGENT_IN_PORTAL_FLAG,
} from '@/Pages/SinglePatientDetails/OneStepAgentPanel/agentUrlState';
import { withCarriedParams } from '@/utils/withCarriedParams';

const OPEN_PANEL_PARAMS = [AGENT_PARAM];

export const usePatientPageNavigate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const isAgentPanelEnabled = useFeatureFlagEnabled(ONESTEP_AGENT_IN_PORTAL_FLAG);

  const patientPageHref = useCallback(
    (to: string) => (isAgentPanelEnabled ? withCarriedParams(to, search, OPEN_PANEL_PARAMS) : to),
    [isAgentPanelEnabled, search],
  );

  const navigateToPatientPage = useCallback(
    (to: string, ...options: [NavigateOptions?]) => navigate(patientPageHref(to), ...options),
    [navigate, patientPageHref],
  );

  return { patientPageHref, navigateToPatientPage };
};
